import React from "react";
import { Container } from "react-bootstrap";
import UnderlinedHeader from "../../../molecules/UnderlinedHeader/UnderlinedHeader";
import useSmallNav from "../../../../hooks/useSmallNav";
import InfoHero from "../../../molecules/info/InfoHero/InfoHero";
import InfoGrid from "../../../atoms/info/InfoGrid/InfoGrid";
import InfoHeader from "../../../atoms/info/InfoHeader/InfoHeader";
import styled from "styled-components";
import InfoCard from "../../../molecules/info/InfoCard/InfoCard";
import InfoFooter from "../../../organisms/InfoFooter/InfoFooter";
import forester from "./../../../../assets/info/forester-hero.jpg";
import fit1 from "./../../../../assets/info/subaru-forester/levelling-fig-1.jpg";
import fit2 from "./../../../../assets/info/subaru-forester/levelling-fig-2.jpg";
import fit3 from "./../../../../assets/info/subaru-forester/levelling-fig-3.jpg";
import { popularVehicle } from "../../../../vars/popularVehicles";

const SubaruForester = () => {
  useSmallNav("Subaru Forester");

  return (
    <section className={"popular"}>
      <Container>
        <UnderlinedHeader text={"Subaru Forester"} bolder />
        <InfoHero image={forester} />
        <InfoGrid>
          <div>
            <InfoHeader
              text={
                "Wyceniałeś już nowe samopoziomujące zawieszenie do Subaru Forester?"
              }
            />
            <p>
              Jeśli spotkałeś się z taką ofertą, wiesz, że są one bardzo drogie!
              Pedders ma dla Ciebie optymalne rozwiązanie. Oferujemy zamienny
              zestaw sprężyn i amortyzatorów na tylną oś Twojego Forestera,
              który wyeliminuje kłopoty z układem samopoziomowania (SLS - self
              leveling system). Specjalnie zaprojektowane do tego amortyzatory i
              sprężyny zapewniają osiągnięcie oczekiwanego rezultatu.
            </p>
            <p>
              Ten zestaw to bezpośredni zmiennik. Nie są wymagane żadne
              modyfikacje pojazdu. Nie są wymagane żadne dodatkowe części.
              Podczas montażu będziesz oczywiście musiał ponownie użyć
              oryginalnego górnego mocowania kolumny (wybrane modele). Ściągacz
              do sprężyn będzie niezbędny.
            </p>
            <p>
              Czy mój pojazd powróci do pierwotnej wysokości? Tak, zdecydowanie!
              Istnieje wiele przykładów Foresterów, które po wymianie
              samopoziomujących amortyzatorów na zwykłe, nie były w stanie
              zachować standardowej wysokości. Dzieje się tak, ponieważ
              oryginalna sprężyna jest zbyt słaba, aby wytrzymać cały ciężar
              samochodu. W układzie SLS pomaga jej w tym amortyzator
              samopoziomujący.
            </p>
            <p>
              Zawieszenie Pedders rozwiązuje ten problem, dostarczając
              specjalnie do tego celu dopasowany zestaw amortyzatorów i sprężyn.
              Możesz być pewien, że pojazd będzie miał odpowiednią wysokość, a
              Twoje kłopotliwe i drogie amortyzatory samopoziomujące przejdą do
              historii.
            </p>
            <iframe
              title="Subaru Forester"
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/KnT6sI4QaYk"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
            <iframe
              title="Subaru Forester"
              width="100%"
              height="300"
              src="https://www.youtube.com/embed/g1aSCo4S2_E"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          </div>
          <div>
            <InfoHeader
              size="smaller"
              text={"Pedders „EziFit” Amortyzatory & Sprężyny"}
            />
            <p>
              Pedders zawsze stara się dawać więcej klientom. Z dumą
              prezentujemy naszą ofertę do Subaru Forester. Ezi Fit!
            </p>
            <p>
              Zamiast kupować oddzielnie sprężyny, amortyzatory, odbojniki i
              górne mocowania, a następnie płacić mechanikowi za demontaż i
              ponowny montaż części, możesz teraz kupić kompletną kolumnę i po
              prostu zamontować ją w prosty sposób! Aktualnie kolumny Ezi FIt
              możesz dobrać do wybranych modeli Forestera - SG, SH, SJ na
              standardowej wysokości jak i podniesionej - dla modeli z
              instalacją LPG.
            </p>
            {popularVehicle
              .find((e) => e.make === "Subaru")
              .models.find((e) => e.display === "Forester")
              .popular.map((item) => (
                <InfoCard
                  key={item.text}
                  name={item.text}
                  to={item.link}
                  photo={item.photo}
                />
              ))}
          </div>
        </InfoGrid>
        <div>
          <InfoHeader
            size="smaller"
            margin
            text={
              "Nie jesteś pewien, czy masz zamontowane samopoziomujące amortyzatory?"
            }
            centered
          />
          <Fitted>
            <div>
              <img
                src={fit1}
                alt={
                  "Nie jesteś pewien, czy masz zamontowane samopoziomujące amortyzatory?"
                }
              />
              <p>
                W niektórych wcześniejszych modelach Subaru Forester, występują
                jeszcze niebieskie/zielone amortyzatory. Są łatwe do
                zidentyfikowania. Późniejsze mogą być już pomalowane na czarno.
                Te mogą być zidentyfikowane tylko po numerze części. Oczywistą
                zaletą jest to, że pojazd osadzony jest niżej niż zwykle, a
                sprężyny wyglądają OK.
              </p>
            </div>
            <div>
              <img
                src={fit2}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Forester SG - Jest to dość łatwe do potwierdzenia. Pojazdy z
                samopoziomującym amortyzatorem mają zbiornik zamocowany z jego
                boku, jak pokazano na powyższym zdjęciu. Jeśli nie ma
                zamontowanego zbiorniczka oznacza to, że nie są samopoziomujące.
              </p>
            </div>
            <div>
              <img
                src={fit3}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Modele Forester SH posiadają „wybrzuszenie” na dole
                standardowego amortyzatora.
              </p>
            </div>
            <div>
              <img
                src={fit3}
                alt={"Not sure if you have self levelling fitted?"}
              />
              <p>
                Modele Forester SJ posiadają „wybrzuszenie” na dole
                standardowego amortyzatora.
              </p>
            </div>
          </Fitted>
        </div>
        <div>
          <InfoHeader
            text={"Nie masz pewności, którą wersję Forester posiadasz?"}
            centered
            margin
            size="smaller"
          />
          <p>
            Najprostszym sposobem jest sprawdzenie numeru VIN. Znajduje się na
            słupku B, po otwarciu drzwi kierowcy. Czwarta i piąta cyfra to SF,
            SG lub SH. Gdy już to wiesz, możesz wybrać swój model z poniższego
            menu.
          </p>
        </div>
        {/* <InfoFooter make="Subaru" model="Forester" /> */}
      </Container>
    </section>
  );
};

export default SubaruForester;

const Fitted = styled.div`
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(1, 1fr);

  img {
    width: auto;
    margin-bottom: 20px;
  }

  @media (min-width: 768px) {
    margin-top: 20px;
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    column-gap: 20px;
    img {
      width: auto;
      margin-bottom: 20px;
      max-height: 200px;
    }
  }
`;
